export const spotlightGridClass = 'ql-spotlightgrid-container';
export const innerBlocksClass = 'ql-spotlightgrid-innerblocks';
export const defaults = {
    cardCount: 6,
    title: "Recommended For You"
}
